import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { db } from '../../firebase';
// Removed incorrect CSS import

// Reusable styled components (similar to RegisterPage)
const StyledCard = ({ children }) => (
  <div style={{ backgroundColor: 'white', padding: '2rem', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', width: '100%', maxWidth: '500px', margin: '2rem auto' }}>{children}</div>
);

const StyledInput = ({ label, type = 'text', name, value, onChange, error, disabled = false }) => (
  <div style={{ marginBottom: '1rem' }}>
    <label style={{ display: 'block', marginBottom: '0.5rem' }}>{label}</label>
    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      disabled={disabled}
      style={{ width: '100%', padding: '0.75rem', border: `1px solid ${error ? 'red' : '#ccc'}`, borderRadius: '4px', fontSize: '1rem', backgroundColor: disabled ? '#e9ecef' : 'white' }}
    />
    {error && <span style={{ color: 'red', fontSize: '0.875rem' }}>{error}</span>}
  </div>
);

const StyledButton = ({ children, onClick, disabled, type = 'button' }) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled}
    style={{ width: '100%', padding: '0.75rem', backgroundColor: '#1976d2', color: 'white', border: 'none', borderRadius: '4px', fontSize: '1rem', cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.7 : 1, marginTop: '1rem' }}
  >
    {children}
  </button>
);

const StyledAlert = ({ type, children }) => (
  <div style={{ padding: '0.75rem', marginBottom: '1rem', borderRadius: '4px', backgroundColor: type === 'error' ? '#fdeded' : '#edf7ed', color: type === 'error' ? '#5f2120' : '#1e4620', border: `1px solid ${type === 'error' ? '#ef5350' : '#4caf50'}` }}>
    {children}
  </div>
);

const EditProfileMahasiswa = () => {
  const navigate = useNavigate();
  const auth = getAuth();
  const [user, setUser] = useState(null); // Will contain role, email, uid, nama, nim/nip, programStudi
  const [formData, setFormData] = useState({ nama: '', nim: '', nip: '', programStudi: '' }); // Added nip
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Fetch user data on mount
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        const userRef = doc(db, 'users', currentUser.uid);
        try {
          const userSnap = await getDoc(userRef);
          if (userSnap.exists()) {
            const userData = userSnap.data();
            // Allow both mahasiswa and dosen
            if (userData.role === 'mahasiswa' || userData.role === 'dosen') {
              setUser({ uid: currentUser.uid, email: userData.email, ...userData });
              setFormData({
                nama: userData.nama || '',
                nim: userData.nim || '', // Will be empty for dosen
                nip: userData.nip || '', // Will be empty for mahasiswa
                programStudi: userData.programStudi || '' // Only relevant for mahasiswa?
              });
            } else {
              setError('Anda tidak diizinkan mengakses halaman profil ini.');
              navigate('/dashboard'); // Redirect other roles to base dashboard
            }
          } else {
             setError('Profil pengguna tidak ditemukan.');
             navigate('/login'); // Redirect if user doc missing
          }
        } catch (err) {
          console.error("Error fetching user profile:", err);
          setError('Gagal memuat profil pengguna.');
        } finally {
          setLoading(false);
        }
      } else {
        setError('Silakan login untuk mengedit profil.');
        navigate('/login'); // Redirect to login if not authenticated
      }
    });
    return () => unsubscribe();
  }, [auth, navigate]);

  // Handle form input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user) {
      setError('Pengguna tidak ditemukan.');
      return;
    }
    // Role-specific validation
    if (user.role === 'mahasiswa' && (!formData.nama || !formData.nim || !formData.programStudi)) {
      setError('Nama, NIM, dan Program Studi wajib diisi untuk mahasiswa.');
      return;
    }
    if (user.role === 'dosen' && (!formData.nama || !formData.nip)) {
      setError('Nama dan NIP wajib diisi untuk dosen.');
      return;
    }

    setIsSubmitting(true);
    setError('');
    setSuccess('');

    try {
      const userRef = doc(db, 'users', user.uid);
      const updateData = {
        nama: formData.nama,
      };
      // Add role-specific fields to update
      if (user.role === 'mahasiswa') {
        updateData.nim = formData.nim;
        updateData.programStudi = formData.programStudi;
      } else if (user.role === 'dosen') {
        updateData.nip = formData.nip;
      }

      await updateDoc(userRef, updateData);

      setSuccess('Profil berhasil diperbarui!');
      // Update local user state with potentially changed fields
      setUser(prev => ({ ...prev, ...updateData }));
      setIsEditing(false);

    } catch (err) {
      console.error("Error updating profile:", err);
      setError('Gagal memperbarui profil.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (loading) {
    return <div style={{ textAlign: 'center', marginTop: '2rem' }}>Memuat profil...</div>;
  }

  // Function to handle entering edit mode
  const handleEditClick = () => {
    setIsEditing(true);
    setSuccess(''); // Clear success message when starting edit
    setError(''); // Clear error message
  };

  // Function to handle cancelling edit mode
  const handleCancelClick = () => {
    setIsEditing(false);
    // Reset form data to original user data
    setFormData({
      nama: user?.nama || '', // Reset nama
      nim: user?.nim || '',
      programStudi: user?.programStudi || ''
    });
    setError('');
  };


  return (
    <StyledCard>
      <h1 style={{ fontSize: '1.5rem', textAlign: 'center', marginBottom: '1.5rem', color: '#1976d2' }}>
        {user?.role === 'dosen' ? 'Profil Dosen' : 'Profil Mahasiswa'}
      </h1>

      {error && !isEditing && <StyledAlert type="error">{error}</StyledAlert>} {/* Show general errors only when not editing */}
      {success && <StyledAlert type="success">{success}</StyledAlert>}

      {/* Display Section (Read-only) */}
      <div style={{ marginBottom: '2rem', paddingBottom: '1rem', borderBottom: '1px solid #eee' }}>
         <p><strong>Nama:</strong> {user?.nama || 'N/A'}</p>
         <p><strong>Email:</strong> {user?.email || 'N/A'}</p>
         {/* Show NIM for Mahasiswa, NIP for Dosen */}
         {user?.role === 'mahasiswa' && <p><strong>NIM:</strong> {user?.nim || '(Belum diisi)'}</p>}
         {user?.role === 'dosen' && <p><strong>NIP:</strong> {user?.nip || '(Belum diisi)'}</p>}
         {user?.role === 'mahasiswa' && <p><strong>Program Studi:</strong> {user?.programStudi || '(Belum diisi)'}</p>}
         {!isEditing && (
           <button
             onClick={handleEditClick}
             style={{ padding: '0.5rem 1rem', backgroundColor: '#ffc107', color: 'black', border: 'none', borderRadius: '4px', cursor: 'pointer', marginTop: '1rem' }}
           >
             Edit Profil
           </button>
         )}
      </div>


      {/* Edit Form Section (Conditional) */}
      {isEditing && (
        <form onSubmit={handleSubmit}>
          <h2 style={{ fontSize: '1.2rem', marginBottom: '1rem' }}>Edit Detail</h2>
          {error && <StyledAlert type="error">{error}</StyledAlert>} {/* Show errors within the form when editing */}
          <StyledInput
            label="Email"
            type="email"
          name="email"
          value={user?.email || ''}
          disabled // Email is never editable
        />
         {/* Added Nama Input */}
        <StyledInput
          label="Nama Lengkap"
          type="text"
          name="nama"
          value={formData.nama}
          onChange={handleChange}
          error={error && error.includes('Nama') ? error : ''}
          required
          disabled={!isEditing || isSubmitting}
        />
        {/* Conditional NIM/NIP/Prodi Inputs */}
        {user?.role === 'mahasiswa' && (
          <>
            <StyledInput
              label="NIM"
              type="text"
              name="nim"
              value={formData.nim}
              onChange={handleChange}
              error={error && error.includes('NIM') ? error : ''}
              required
              disabled={!isEditing || isSubmitting}
            />
            <StyledInput
              label="Program Studi"
              type="text"
              name="programStudi"
              value={formData.programStudi}
              onChange={handleChange}
              error={error && error.includes('Program Studi') ? error : ''}
              required
              disabled={!isEditing || isSubmitting}
            />
          </>
        )}
        {user?.role === 'dosen' && (
          <StyledInput
            label="NIP"
            type="text"
            name="nip"
            value={formData.nip}
            onChange={handleChange}
            error={error && error.includes('NIP') ? error : ''}
            required
            disabled={!isEditing || isSubmitting}
          />
        )}
        {/* Show Save and Cancel only when editing */}
        {isEditing && (
          <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
            <StyledButton type="submit" disabled={isSubmitting} style={{ flexGrow: 1, margin: 0 }}>
              {isSubmitting ? 'Menyimpan...' : 'Simpan Perubahan'}
            </StyledButton>
            <button
              type="button"
              onClick={handleCancelClick}
              disabled={isSubmitting}
              style={{ flexGrow: 1, padding: '0.75rem', backgroundColor: '#6c757d', color: 'white', border: 'none', borderRadius: '4px', fontSize: '1rem', cursor: 'pointer', margin: 0 }}
            >
              Batal
            </button>
          </div>
        )}
        </form>
      )}

      {/* Keep dashboard button outside the conditional form, navigate to correct path */}
      {!isEditing && (
         <button
            onClick={() => navigate('/dashboard')} // Navigate to the unified dashboard
            style={{ width: '100%', padding: '0.75rem', backgroundColor: '#6c757d', color: 'white', border: 'none', borderRadius: '4px', fontSize: '1rem', cursor: 'pointer', marginTop: '1rem' }}
          >
            Kembali ke Dashboard
          </button>
      )}
    </StyledCard>
  );
};

export default EditProfileMahasiswa;
